<template>
	<div class="home-container">
		<div class="home-scroll">
			<!-- 顶部 Logo 区域 -->
			<div class="logo-box">
				<img src="/img/two/logo.4228a5ba.webp" width="30%">
			</div>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="top-banner-wrapper">
					<swiper v-if="topProducts.length > 0" class="top_swiper" :options="topSwiperOption">
						<swiper-slide v-for="v in topProducts" :key="v.id">
							<div class="banner-item">
								<van-image class="banner_img" fit="cover" :src="v.cover" />
							</div>
						</swiper-slide>
						<div class="swiper-pagination" slot="pagination"></div>
					</swiper>
				</div>

			</van-pull-refresh>
			<div class="intro-text">
				<h2 data-v-3b8e07fe="" style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;"><a data-v-3b8e07fe="" href="#/login"><span data-v-3b8e07fe="" style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong data-v-3b8e07fe="">파티 상품</strong></span></a></h2>
			</div>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="category-wrapper">
					<div class="swiper-container-box">
						<swiper v-if="menProducts.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in menProducts" :key="'men-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
										<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
									</div>
								</div>
							</swiper-slide>
							<!-- 小圆点插槽 -->
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>
				<div class="category-wrapper">
					<div class="swiper-container-box">
						<swiper v-if="womenProducts.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in womenProducts" :key="'women-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>

			</van-pull-refresh>
			
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div><h2 data-v-3b8e07fe="" style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;"><a data-v-3b8e07fe="" href="#/login"><span data-v-3b8e07fe="" style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong data-v-3b8e07fe="">쿠폰 대상 인기 아이템</strong></span></a></h2>
</div>
				<div class="category-wrapper">
					<div class="swiper-container-box">
						<swiper v-if="hot3Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in hot3Products" :key="'hot3-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<div class="tag">남성 탑 HOT</div>
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<img class="rank-badge" v-if="key < 3" :src="'/img/home/no' + (key + 1) + '.png'">
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
										<div class="old-price">₩ {{ v.old_price }}</div>
									</div>
								</div>
							</swiper-slide>
							<!-- 小圆点插槽 -->
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>
<div><h2 data-v-3b8e07fe="" style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;"><a data-v-3b8e07fe="" href="#/login"><span data-v-3b8e07fe="" style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong data-v-3b8e07fe="">체크한 아이템</strong></span></a></h2>
</div>
				<div class="category-wrapper">
					<div class="swiper-container-box">
						<swiper v-if="hot4Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in hot4Products" :key="'hot4-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<div class="tag-women">여성용</div>
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>

			</van-pull-refresh>
			<div><h2 data-v-3b8e07fe="" style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;"><a data-v-3b8e07fe="" href="#/login"><span data-v-3b8e07fe="" style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong data-v-3b8e07fe="">카테고리에서 검색</strong></span></a></h2>
</div>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">

				

			</van-pull-refresh>
			<h2 data-v-3b8e07fe="" style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;"><a data-v-3b8e07fe="" href="#/login"><span data-v-3b8e07fe="" style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong data-v-3b8e07fe="">24시간 타임 세일</strong></span></a></h2>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="category-wrapper">
					<div class="swiper-container-box">
						<swiper v-if="hot5Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in hot5Products" :key="'hot5-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
									</div>
								</div>
							</swiper-slide>
							<!-- 小圆点插槽 -->
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>


			</van-pull-refresh>
			<h2 data-v-3b8e07fe="" style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;"><a data-v-3b8e07fe="" href="#/login"><span data-v-3b8e07fe="" style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong data-v-3b8e07fe="">고향 납세 인기 반례품</strong></span></a></h2>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="category-wrapper">
					<div class="swiper-container-box">
						<swiper v-if="hot6Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in hot6Products" :key="'hot6-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
									</div>
								</div>
							</swiper-slide>
							<!-- 小圆点插槽 -->
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>
			</van-pull-refresh>
			<h2 data-v-3b8e07fe="" style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;"><a data-v-3b8e07fe="" href="#/login"><span data-v-3b8e07fe="" style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong data-v-3b8e07fe="">가게에서 강추 상품</strong></span></a></h2>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="category-wrapper">
					<div class="swiper-container-box">
						<swiper v-if="hot7Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in hot7Products" :key="'hot7-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
									</div>
								</div>
							</swiper-slide>
							<!-- 小圆点插槽 -->
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>


			</van-pull-refresh>
			
			<h2 data-v-3b8e07fe="" style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;"><a data-v-3b8e07fe="" href="#/login"><span data-v-3b8e07fe="" style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong data-v-3b8e07fe="">HOT! TREND</strong></span></a></h2>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="top-banner-wrapper">
					<swiper v-if="hot8Products.length > 0" class="top_swiper" :options="topSwiperOption">
						<swiper-slide v-for="v in hot8Products" :key="v.id">
							<div class="banner-item">
								<van-image class="banner_img" fit="cover" :src="v.cover" />
							</div>
						</swiper-slide>
						<div class="swiper-pagination" slot="pagination"></div>
					</swiper>
				</div>

			</van-pull-refresh>
				<div class="category-wrapper">
					<div class="swiper-container-box">
						<swiper v-if="hot82Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in hot82Products" :key="'hot82-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>


			</van-pull-refresh>
			
			<div style="width: 100%; background-color: antiquewhite;">
				<div class="wo">
					<div style="float: left;width: 50%;"><img src="/img/loginhome/footer1.35de1a0a.png"></div>
					<div style="float:right;width: 50%;"><img src="/img/loginhome/footer2.7b17382c.png"></div>
				</div>
				<div class="wo">
					<div style="float: left;width: 50%;"><img src="/img/loginhome/footer3.72eb04d3.png"></div>
					<div style="float:right;width: 50%;"><img src="/img/loginhome/footer4.23c66537.png"></div>
				</div>
				<div class="end">
					
					<span>｜쇼핑 정보｜</span><br>
					Serene Love클럽에 대하여<br>
					이용약관<br>
					개인정보처리방침<br>
					판매 대리
					<br>신청 매장 정보
					<br><span>｜쇼핑 가이드｜</span>
					<br>배송 및 결제 반품 및 교환 안내
					<br>제조물 책임 보험<br>사기 방지 안내<br>자주 묻는 질문
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isLoading: false,
			// ==========================================	
			// 这里的数组就是你要手动修改的产品数据
			// ==========================================
			menProducts: [
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/two/s (1).jpg' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/two/s (2).jpg' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/two/s (3).jpg' },
				{ id: 4, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/two/s (4).jpg' },
				{ id: 5, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/two/s (5).jpg' },
				{ id: 6, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/two/s (6).jpg' },
				{ id: 7, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/two/s (7).jpg' }
			],
			topProducts: [
				{ id: 1, cover: '/img/two/swipe1s.03251d60.jpg' },
				{ id: 2, cover: '/img/two/swipe2s.f4d75dc1.jpg' },
				{ id: 3, cover: '/img/two/swipe3s.5b83bbe6.jpg' },
				{ id: 4, cover: '/img/two/swipe4s.118fb633.jpg' },
				{ id: 5, cover: '/img/two/swipe5s.568b25b0.jpg' },
				{ id: 6, cover: '/img/two/swipe6s.c591b503.jpg' }
			],
			womenProducts: [
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/two/s (8).jpg' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/two/s (9).jpg' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/two/s (10).jpg' },
				{ id: 4, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/two/s (11).jpg' },
				{ id: 5, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/two/s (12).jpg' },
				{ id: 6, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/two/s (13).jpg' }
			],
			hot3Products: [
				{ id: 1, title: 'Rose Vibrator', price: '25,000', old_price: '35,000', cover: '/img/two/pdt (1).jpg' },
				{ id: 2, title: 'Magic Wand', price: '45,000', old_price: '60,000', cover: '/img/two/pdt (2).jpg' },
				{ id: 3, title: 'App Control Toy', price: '55,000', old_price: '70,000', cover: '/img/two/pdt (3).jpg' },
				{ id: 4, title: 'Rose Vibrator1', price: '25,000', old_price: '35,000', cover: '/img/two/pdt (4).jpg' },
				{ id: 5, title: 'Magic Wand1', price: '45,000', old_price: '60,000', cover: '/img/two/pdt (5).jpg' },
				{ id: 6, title: 'App Control Toy', price: '55,000', old_price: '70,000', cover: '/img/two/pdt (6).jpg' },
				{ id: 7, title: 'Rose Vibrator', price: '25,000', old_price: '35,000', cover: '/img/two/pdt (7).jpg' },
				{ id: 8, title: 'Magic Wand', price: '45,000', old_price: '60,000', cover: '/img/two/pdt (8).jpg' },
				{ id: 9, title: 'App Control Toy', price: '55,000', old_price: '70,000', cover: '/img/two/pdt (9).jpg' },
				{ id: 10, title: 'Rose Vibrator', price: '25,000', old_price: '35,000', cover: '/img/two/pdt (10).jpg' },
				{ id: 11, title: 'Magic Wand', price: '45,000', old_price: '60,000', cover: '/img/two/pdt (11).jpg' },
				{ id: 12, title: 'App Control Toy', price: '55,000', old_price: '70,000', cover: '/img/two/pdt (12).jpg' },
				{ id: 13, title: 'Rose Vibrator', price: '25,000', old_price: '35,000', cover: '/img/two/pdt (13).jpg' },
				{ id: 14, title: 'Magic Wand', price: '45,000', old_price: '60,000', cover: '/img/two/pdt (14).jpg' },
				{ id: 15, title: 'App Control Toy', price: '55,000', old_price: '70,000', cover: '/img/two/pdt (15).jpg' }
			],
			hot4Products: [
				{ id: 101, title: '플랜디 데일리 바캉스 바스락 햇빛차단 턱끈 버킷햇', price: '12,900', cover: '/img/two/bb1 (1).jpg' },
				{ id: 102, title: '엘블로썸 여성 투버튼 롱 와이드 청바지 [사이드 리벳 포인트]', price: '19,000', cover: '/img/two/bb1 (2).jpg' },
				{ id: 100, title: '팀스핏(품질보증) 남성용 30~38 세미 와이드 청바지 프리미엄 코튼 데님팬츠 빅사이즈할인', price: '39,800', cover: '/img/two/bb1 (3).jpg' },
				{ id: 103, title: 'SHOPPI 리얼 소가죽 여성 데일리 백팩 캐쥬얼 배낭쿠폰할인', price: '64,700', cover: '/img/two/bb1 (4).jpg' },
				{ id: 104, title: '맨즈셀렉터 남자 카고 반바지', price: '21,800', cover: '/img/two/bb1 (5).jpg' },
				{ id: 105, title: '[담앤드솜 2세대 심플 미니 힙색] 허리 어깨 방수 스포츠 운동 조깅 가슴 ', price: '17,900', cover: '/img/two/bb1 (6).jpg' },
				{ id: 106, title: '베이직바이블 쿨링 아이스 투턱 와이드 조거 스트링 밴딩 스판 슬랙스 팬츠(4color)', price: '27,900', cover: '/img/two/bb1 (7).jpg' },
				{ id: 107, title: '[2PACK/AS가능] 지프 JEEP 반팔 티셔츠 남녀공용 반팔티 오버핏 레이어드 커플', price: '39,500', cover: '/img/two/bb1 (8).jpg' },
				{ id: 108, title: '제로투히어로 남성용 헬스 버뮤다 팬츠', price: '29,900', cover: '/img/two/bb1 (9).jpg' },
				{ id: 109, title: '썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인', price: '12,500', cover: '/img/two/bb1 (10).jpg' },
				{ id: 110, title: '썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인', price: '12,500', cover: '/img/two/bb1 (11).jpg' },

			],
			hot5Products: [
				{ id: 101, title: '플랜디 데일리 바캉스 바스락 햇빛차단 턱끈 버킷햇', price: '12,900', cover: '/img/two/ss (1).png' },
				{ id: 102, title: '엘블로썸 여성 투버튼 롱 와이드 청바지 [사이드 리벳 포인트]', price: '19,000', cover: '/img/two/ss (2).png' },
				{ id: 100, title: '팀스핏(품질보증) 남성용 30~38 세미 와이드 청바지 프리미엄 코튼 데님팬츠 빅사이즈할인', price: '39,800', cover: '/img/two/ss (3).png' },
				{ id: 103, title: 'SHOPPI 리얼 소가죽 여성 데일리 백팩 캐쥬얼 배낭쿠폰할인', price: '64,700', cover: '/img/two/ss (4).png' },
				{ id: 104, title: '맨즈셀렉터 남자 카고 반바지', price: '21,800', cover: '/img/two/ss (5).png' },
				{ id: 105, title: '[담앤드솜 2세대 심플 미니 힙색] 허리 어깨 방수 스포츠 운동 조깅 가슴 ', price: '17,900', cover: '/img/two/ss (6).png' },
				{ id: 106, title: '베이직바이블 쿨링 아이스 투턱 와이드 조거 스트링 밴딩 스판 슬랙스 팬츠(4color)', price: '27,900', cover: '/img/two/ss (7).png' },
				{ id: 107, title: '[2PACK/AS가능] 지프 JEEP 반팔 티셔츠 남녀공용 반팔티 오버핏 레이어드 커플', price: '39,500', cover: '/img/two/ss (8).png' },
				{ id: 108, title: '제로투히어로 남성용 헬스 버뮤다 팬츠', price: '29,900', cover: '/img/two/ss (9).png' },
				{ id: 109, title: '썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인', price: '12,500', cover: '/img/two/ss (10).png' },
				{ id: 110, title: '썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인', price: '12,500', cover: '/img/two/ss (11).png' },

			],
			hot6Products: [
				{ id: 101, title: '플랜디 데일리 바캉스 바스락 햇빛차단 턱끈 버킷햇', price: '12,900', cover: '/img/two/pp (1).jpg' },
				{ id: 102, title: '엘블로썸 여성 투버튼 롱 와이드 청바지 [사이드 리벳 포인트]', price: '19,000', cover: '/img/two/pp (2).jpg' },
				{ id: 100, title: '팀스핏(품질보증) 남성용 30~38 세미 와이드 청바지 프리미엄 코튼 데님팬츠 빅사이즈할인', price: '39,800', cover: '/img/two/pp (3).jpg' },
				{ id: 103, title: 'SHOPPI 리얼 소가죽 여성 데일리 백팩 캐쥬얼 배낭쿠폰할인', price: '64,700', cover: '/img/two/pp (4).jpg' },
				{ id: 104, title: '맨즈셀렉터 남자 카고 반바지', price: '21,800', cover: '/img/two/pp (5).jpg' },
				{ id: 105, title: '[담앤드솜 2세대 심플 미니 힙색] 허리 어깨 방수 스포츠 운동 조깅 가슴 ', price: '17,900', cover: '/img/two/pp (6).jpg' },
				{ id: 106, title: '베이직바이블 쿨링 아이스 투턱 와이드 조거 스트링 밴딩 스판 슬랙스 팬츠(4color)', price: '27,900', cover: '/img/two/pp (7).jpg' },
				{ id: 107, title: '[2PACK/AS가능] 지프 JEEP 반팔 티셔츠 남녀공용 반팔티 오버핏 레이어드 커플', price: '39,500', cover: '/img/two/pp (8).jpg' },
				{ id: 108, title: '제로투히어로 남성용 헬스 버뮤다 팬츠', price: '29,900', cover: '/img/two/pp (9).jpg' },
				{ id: 109, title: '썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인', price: '12,500', cover: '/img/two/pp (1).png' },
				{ id: 110, title: '썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인', price: '12,500', cover: '/img/two/pp (2).png' },

			],
			hot7Products: [
				{ id: 101, title: '플랜디 데일리 바캉스 바스락 햇빛차단 턱끈 버킷햇', price: '12,900', cover: '/img/two/pk1.da5ab54e.jpg' },
				{ id: 102, title: '엘블로썸 여성 투버튼 롱 와이드 청바지 [사이드 리벳 포인트]', price: '19,000', cover: '/img/two/pk2.786b781a.jpg' },
				{ id: 100, title: '팀스핏(품질보증) 남성용 30~38 세미 와이드 청바지 프리미엄 코튼 데님팬츠 빅사이즈할인', price: '39,800', cover: '/img/two/pk3.3e94613b.jpg' },
				{ id: 103, title: 'SHOPPI 리얼 소가죽 여성 데일리 백팩 캐쥬얼 배낭쿠폰할인', price: '64,700', cover: '/img/two/pk4.b1ab6dee.jpg' },
				{ id: 104, title: '맨즈셀렉터 남자 카고 반바지', price: '21,800', cover: '/img/two/pk5.bf3a1e14.png' },
				{ id: 105, title: '[담앤드솜 2세대 심플 미니 힙색] 허리 어깨 방수 스포츠 운동 조깅 가슴 남자 돈 웨이스트 메신저 크로스 슬링백 러닝 허리쌕 가방 지갑 파우치 쌕 소형 작은 등산 자전거', price: '17,900', cover: '/img/two/pk6.cafafb5b.jpg' },
				{ id: 106, title: '베이직바이블 쿨링 아이스 투턱 와이드 조거 스트링 밴딩 스판 슬랙스 팬츠(4color)', price: '27,900', cover: '/img/two/pk7.cf8b7414.jpg' },
				{ id: 107, title: '[2PACK/AS가능] 지프 JEEP 반팔 티셔츠 남녀공용 반팔티 오버핏 레이어드 커플', price: '39,500', cover: '/img/two/pk8.fb42006e.jpg' },
				{ id: 108, title: '제로투히어로 남성용 헬스 버뮤다 팬츠', price: '29,900', cover: '/img/two/pk9.e7654d71.jpg' },
				{ id: 109, title: '썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인', price: '12,500', cover: '/img/two/pk10.98ef0cd1.jpg' },
			],
			hot8Products: [
				{ id: 1, cover: '/img/two/hot1.af68fee3.png' },
				{ id: 2, cover: '/img/two/hot2.701f85a8.png' },
				{ id: 3, cover: '/img/two/hot3.2c72e7e1.png' },
				{ id: 4, cover: '/img/two/hot4.ccb63633.png' },
				{ id: 5, cover: '/img/two/hot5.38405a4c.png' },
				{ id: 6, cover: '/img/two/hot6.a642dd0a.png' },
				{ id: 7, cover: '/img/two/hot7.16fa7434.png' },
				{ id: 8, cover: '/img/two/hot8.b708be98.png' },
				{ id: 9, cover: '/img/two/hot9.65efb305.png' },
				{ id: 10, cover: '/img/two/hot10.f7b44bbc.png' },
				{ id: 11, cover: '/img/two/hot11.e686e1af.png' },
				{ id: 12, cover: '/img/two/hot12.a7d98d75.png' },
				{ id: 13, cover: '/img/two/hot13.12f9ad4a.png' },
				{ id: 14, cover: '/img/two/hot14.59a781eb.jpg' },
			],
			hot82Products: [
				{ id: 101, title: '플랜디 데일리 바캉스 바스락 햇빛차단 턱끈 버킷햇', price: '12,900', cover: '/img/two/hotpd1.256dcd49.png' },
				{ id: 102, title: '엘블로썸 여성 투버튼 롱 와이드 청바지 [사이드 리벳 포인트]', price: '19,000', cover: '/img/two/hotpd2.5984cce2.jpg' },
				{ id: 100, title: '팀스핏(품질보증) 남성용 30~38 세미 와이드 청바지 프리미엄 코튼 데님팬츠 빅사이즈할인', price: '39,800', cover: '/img/two/hotpd3.b86d9d32.jpg' },
				{ id: 103, title: 'SHOPPI 리얼 소가죽 여성 데일리 백팩 캐쥬얼 배낭쿠폰할인', price: '64,700', cover: '/img/two/hotpd5.47ee31e8.jpg' },
				{ id: 104, title: '맨즈셀렉터 남자 카고 반바지', price: '21,800', cover: '/img/two/hotpd6.d02662dd.png' },
				{ id: 105, title: '[담앤드솜 2세대 심플 미니 힙색] 허리 어깨 방수 스포츠 운동 조깅 가슴 남자 돈 웨이스트 메신저 크로스 슬링백 러닝 허리쌕 가방 지갑 파우치 쌕 소형 작은 등산 자전거', price: '17,900', cover: '/img/two/hotpd8.b1bac539.jpg' },
				{ id: 106, title: '베이직바이블 쿨링 아이스 투턱 와이드 조거 스트링 밴딩 스판 슬랙스 팬츠(4color)', price: '27,900', cover: '/img/two/hotpd9.8168fef9.jpg' },
				{ id: 107, title: '[2PACK/AS가능] 지프 JEEP 반팔 티셔츠 남녀공용 반팔티 오버핏 레이어드 커플', price: '39,500', cover: '/img/two/hotpd10.1ec56ce6.png' },
				{ id: 108, title: '제로투히어로 남성용 헬스 버뮤다 팬츠', price: '29,900', cover: '/img/two/hotpd11.d6382d1e.jpg' },
				{ id: 109, title: '썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인', price: '12,500', cover: '/img/two/hotpd12.bf08a822.jpg' },
			],
			// Swiper 轮播图配置
			topSwiperOption: {
				slidesPerView: 1,
				loop: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				// --- 必须添加以下三个参数 ---
				observer: true,                // 修改 swiper 自己或子元素时，自动初始化 swiper
				observeParents: true,          // 修改 swiper 的父元素时，自动初始化 swiper
				loopAdditionalSlides: 3,       // 额外克隆几个滑块，防止循环到最后出现空白
			},
			movielistSwiperOption: {
				slidesPerView: 2.2,
				spaceBetween: 12,
				loop: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				// 关键：确保这里的 el 对应 HTML 里的 class
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				observer: true,
				observeParents: true,
			},
		};
	},
	methods: {
		onRefresh() {
			// 模拟刷新逻辑
			setTimeout(() => {
				this.isLoading = false;
				this.$toast("새로고침 성공");
			}, 1000);
		},
		toPlayVideo(id) {
			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' });
			} else {
				this.$router.push({ path: '/home?id=' + id });
			}
		}
	}
}
</script>

<style lang='less' scoped>
.home-container {
	background-color: #f8f8f8;
	min-height: 100vh;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
}

.logo-box {
	padding: 20px;
	text-align: center;
	background: #fff;
}

.intro-text {
	padding: 10px;
	text-align: center;
	font-size: 24px;
	color: #666;
	background: #fff;

	p {
		margin: 5px 0;
	}
}

.banner-img-wide {
	width: 90%;
	margin: 10px auto;
	display: block;
	border-radius: 10px;
}

.banner-img-full {
	width: 100%;
	display: block;
}

.category-wrapper {
	margin-bottom: 20px;
	background: #fff;
	padding-bottom: 20px;
}

/* 粉色标题栏样式 */
.category-header {
	height: 90px;
	margin: 20px;
	border-radius: 15px;
	display: flex;
	align-items: center;
	padding: 0 30px;
	color: #fff;
	font-size: 32px;
	font-weight: bold;
	background-color: #d64a79;

	.emoji {
		margin-right: 15px;
		font-size: 40px;
	}
}

.swiper-container-box {
	padding: 0 20px;
	overflow: visible;
	/* 关键：允许小圆点显示 */
}

.movie_swiper {
	padding-bottom: 70px !important;
	/* 给底部圆点留出空间 */
	overflow: visible !important;
}

/* 卡片样式 */
.product-card {
	background: #fff;
	border: 1px solid #eee;
	border-radius: 15px;
	position: relative;
	overflow: hidden;
	padding-bottom: 15px;
	height: 100%;

	.tag,
	.tag-women {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
		color: #fff;
		font-size: 18px;
		padding: 5px 15px;
		border-radius: 0 0 15px 0;
		background: #d64a79;
	}

	.tag-women {
		background: #e07094;
	}

	.movie_cover {
		width: 100%;
		height: 280px;
	}

	.rank-badge {
		position: absolute;
		top: 10px;
		right: 10px;
		width: 60px;
		z-index: 10;
	}

	.info-box {
		padding: 15px 10px 5px;

		.title {
			font-size: 26px;
			color: #333;
			height: 34px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.price {
			font-size: 28px;
			color: #d64a79;
			font-weight: bold;
			margin-top: 8px;
		}

		.old-price {
			font-size: 22px;
			color: #999;
			text-decoration: line-through;
			margin-top: 5px;
		}
	}
}
.wo {
	text-align: center;
	margin: 0 auto;
	width: 100%;
	height: 340px;
	margin: 10px;
	
}
.wo img{
	width:80%;
	padding: 10px;
	
}
.end {
	text-align: center;
	padding-bottom: 200px;
	padding-top: 20px;
	font-size: 25px;
}
.end span {
	font-size: 40px;
	font-weight: 900;

}
/* 分页器小圆点样式 */
.movie_swiper {
	/* 必须给底部留出足够的空间放圆点，否则会被 overflow:hidden 遮住 */
	padding-bottom: 60px !important;
	position: relative;
	overflow: visible !important;
	/* 允许圆点溢出显示 */
}

/* 确保圆点本身有颜色（有时候是透明的看不见） */
::v-deep .swiper-pagination {
	bottom: 10px !important;
	/* 调整圆点距离底部的距离 */
	left: 0;
	width: 100%;
	text-align: center;
}

::v-deep .swiper-pagination-bullet {
	width: 12px !important;
	height: 12px !important;
	background: #ccc !important;
	/* 未激活的颜色：灰色 */
	opacity: 1 !important;
	margin: 0 5px !important;
}

::v-deep .swiper-pagination-bullet-active {
	background: #d64a79 !important;
	/* 激活后的颜色：粉色 */
}
</style>